import React from "react";
import { Box, Button, Chip, Typography,Paper } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import ScienceIcon from "@mui/icons-material/Science";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import HubIcon from "@mui/icons-material/Hub";
import OilBarrelIcon from "@mui/icons-material/OilBarrel";
import SpeedIcon from "@mui/icons-material/Speed";
import BubbleChartIcon from "@mui/icons-material/BubbleChart";
import GrainIcon from "@mui/icons-material/Grain";
import { baseURL } from "../Config/config";
import { useNavigate,useLocation } from "react-router-dom";



// Replace these imports with your actual image paths
import selexmodeler from "../images/products/selexmodeler.png";
import selexmodeler1 from "../images/products/selexmodeler1.png";

import selexwell from "../images/products/selexwell.png";
import selexwell1 from "../images/products/selexwell1.png";

import selexsep from "../images/products/selexsep.png";
import selexsep1 from "../images/products/SelexSEP2.png";

import selexad from "../images/products/selexad.png";
import selexad1 from "../images/products/SelexAdsorption.png";

import selexmsd from "../images/products/selexmsd.jpg";
import selexmsd1 from "../images/products/selexmsd1.png";

import selexcam from "../images/products/selexcam.png";
import selexcamvideo from "../images/products/SelexCAM.mp4";


import selexcip from "../images/products/selexcip.png";
import selexcip1 from "../images/products/selexicp1.png";

import selexicarus from "../images/products/selexicarus.jpg";
import selexicarus1 from "../images/products/selexicarus1.png";

import selexsws from "../images/products/selexsws.jpg";
import selexsws1 from "../images/products/selexsws1.png";

import selexstudio from "../images/products/selexstudio.png";
import selexstudiovideo from "../images/products/SelexStudio.mp4";
import selexstudio1 from "../images/products/selexstudio1.png";


import selexrs from "../images/products/selexrs.jpg";
import selexrs1 from "../images/products/SelexRS.png";

import selexdsm from "../images/products/selexdsm.png";
import selexdsm1 from "../images/products/selexdsm1.png";

import selexdmx from "../images/products/selexdmx.jpg";
import selexsru from "../images/products/selexsru.png";

import selexlab from "../images/products/selexlab.jpg";
import selexdmx1 from "../images/products/selexdmx1.png";
import selexsru1 from "../images/products/selexsru1.png";

import selexlab1 from "../images/products/selexlab1.png";


import selexole from "../images/products/selexole.jpg";
import selexole1 from "../images/products/SelexOLE.png";

import selexccr from "../images/products/selexccr.jpg";
import selexccr1 from "../images/products/selexccr1.jpg";

import selexfz from "../images/products/selexfz.png";
import selexfz1 from "../images/products/selexfz1.png";

import selexcms1 from "../images/products/selexcms1.png";
import selexcms from "../images/products/selexcms.jpg";



import selexheater1 from "../images/products/selexheater1.png";
import selexheater from "../images/products/selexheater.jpg";

import selexref1 from "../images/products/selexref1.png";
import selexref from "../images/products/selexref.png";




import selexspec1 from "../images/products/selexspec1.png";
import selexspec from "../images/products/selexspec.png";




import selexp3601 from "../images/products/selexp3601.png";
import selexp360 from "../images/products/selexp360.png";


import selexlng from "../images/products/selexlng.jpg";
import selexlng1 from "../images/products/selexlng1.png";

import selexmppl from "../images/products/selexmppl.png";
import selexmppl1 from "../images/products/selexmppl1.png";

import selexrxn from "../images/products/selexrxn.png";
import selexrxn1 from "../images/products/selexrxn1.png";

import selexmsa from "../images/products/selexmsa.png";
import selexmsa1 from "../images/products/selexmsa1.png";


import SelexSIM from "../images/SelexSIM.png";
import SelexSolNavbar from "./CommonC/SelexSolNavbar";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import Footer from "./Footer";
import SelexAdsorptionLogo from "../images/selexad.png";
import Header from "./Header";
const primary = "#0078c9";
const accent = "#9e0b22";
const navy = "#061d34";

const apps = [
  {
    name: "SelexModeler",
    route: "#",
    logo: selexmodeler,
    icon: <AutoAwesomeIcon />,
    tag: "Digital Twin & Optimization​",
    desc: "Custom ODE/PDE dynamic and distributed process modeling.​​",
    challenges :["Many reactors and transient phenomena have no off-the-shelf model.​","Commercial simulators are heavy, costly and slow to configure for custom units.​","Dynamic and spatial effects get oversimplified, hiding real process risk.​"],
    values :["Build custom dynamic and distributed (ODE/PDE) models where standard tools fall short.​","Capture true transient and gradient behaviour for safer design and operation.​","Lightweight and fast to deploy no heavy simulator licence lock-in.​"],
    descimg:selexmodeler1
  },
  {
    name: "SelexWELL",
    route: "/selexwell",
    logo: selexwell,
    icon: <AnalyticsIcon />,
    tag: "Digital Twin & Optimization​",
    desc: "Dynamic nodal analysis with big-data generation for ROM & soft sensors.​",
    challenges :["Wells drift from optimal lift and choke settings production left underexploited.​","Nodal analysis lives in scattered spreadsheets, rarely refreshed to live conditions.​","Generating enough scenario data for reduced-order models is impractical by hand.​"],
    values :["Dynamic nodal analysis (IPR/VLP) maximises well and system deliverability.​","Mass-generates scenario data for ROMs and production soft sensors.​","Keeps lift, choke and back-pressure aligned to live reservoir and facility conditions.​"],
    descimg:selexwell1
  },
  {
    name: "SelexSEP",
    route: "/selexfcc",
    logo: selexsep,
    icon: <OilBarrelIcon />,
    tag: "Digital Twin & Optimization​",
    desc: "Forecasts separator liquid carryover and desalter salt content (Carryover & Desalter modules, WIO and OIW).​",
    challenges :["Separator liquid carryover damages downstream compressors and trips trains.​","Off-spec desalter salt content drives corrosion, fouling and crude penalties.​","Operators get no early warning problems surface only after a downstream upset.​"],
    values:["Forecasts carryover and treated-crude salt content before they hit downstream units.​","Protects compressors, columns and pipework fewer trips and corrosion events.​","Optimises separation and desalting for spec compliance and stable throughput.​"],
    descimg:selexsep1
  
  },
  {
    name: "SelexAdsorption",
    route: "#",
    logo: selexad,
    icon: <GrainIcon />,
    tag: "Digital Twin & Optimization​",
    desc: "Super thermodynamic model for the solid-bed (molecular-sieve) gas dehydration with advanced features of case study and ROM (Reduced Order Model) for AI-based Solutions​",
    challenges :["Mol-sieve beds run on fixed time cycles, not actual moisture loading.​","Early or late switching wastes regeneration energy and shortens sieve life.​","Bed degradation stays invisible until water breakthrough occurs.​"],
    values:["Optimises dehydration cycles to real moisture loading.​","Prevents water breakthrough that causes hydrates and cryogenic upsets.​","Cuts regeneration energy and extends adsorbent life.​"],
    descimg:selexad1
  },
  {
    name: "SelexMSD",
    route: "/selexmsd",
    logo: selexmsd,
    icon: <HubIcon />,
    tag: "Digital Twin & Optimization​",
    desc: "Material selection engine for optimal material selection .​",
    challenges:["Wrong metallurgy causes corrosion failures, leaks, unplanned shutdowns and HSE exposure.​","Over-conservative specs inflate CAPEX on every line and vessel.​","Material decisions span many standards and mechanisms slow and expert-dependent.​"],
    values:["Right-first-time material selection across the relevant corrosion mechanisms.​","Avoids both integrity failures and costly over-specification.​","Consistent, defensible, standards-based decisions in a fraction of the time.​"],
    descimg:selexmsd1
  },
  {
    name: "SelexCAM",
    route: "/selexcam2",
    logo: selexcam,
    icon: <WaterDropIcon />,
    tag: "Digital Twin & Optimization​",
    desc: "Intelligent capacity asset modeling for assessing the processing facilities against the production profile​",
    challenges:["Facilities are designed for a snapshot, but production profiles change year on year.​","Hidden capacity bottlenecks cap throughput and defer production unnoticed.​","Capacity studies are slow and static out of date before they’re finished.​"],
    values:["Models facility capacity against the evolving production profile to expose true bottlenecks.​","Guides debottlenecking and tie-in decisions to defend and grow throughput.​","Keeps capacity planning live as the field and demand change.​"],
    descimg:selexcamvideo
  },
  {
    name: "SelexCIP",
    route: "/selexcip",
    logo: selexcip,
    icon: <SpeedIcon />,
    tag: "Digital Twin & Optimization​",
    desc: "Corrosion-inhibitor performance & chemical-injection planning to protect pipework at the lowest dosing cost.​",
    challenges:["Inhibitor is often over-dosed ‘to be safe’, wasting expensive chemical.​","Under-dosing risks internal corrosion, leaks and integrity failures.​","Inhibitor effectiveness is rarely tied to real corrosion-rate feedback.​"],
    values:["Right-doses inhibitor to protect pipework at the lowest chemical cost.​","Links injection planning to corrosion performance protection you can prove.​","Cuts chemical OPEX while reducing leak and integrity risk.​"],
    descimg:selexcip1
  },
  {
    name: "SelexICARUS",
    route: "#",
    logo: selexicarus,
    icon: <ScienceIcon />,
    tag: "Digital Twin & Optimization​",
    desc: "Visual equipment specification & sizing engine (API/GPSA/TEMA) with CAPEX estimation and instant RFQ generation.​",
    challenges:["FEED equipment sizing is slow, spreadsheet-driven and inconsistent across disciplines.​","Rough early CAPEX estimates delay and distort investment decisions.​","Datasheet and RFQ preparation is manual and error-prone.​"],
    values:["Standards-based (API/GPSA/TEMA) sizing on a visual P&ID workflow.​","Instant CAPEX estimates for faster, better investment screening.​","Auto-generates datasheets and RFQs, faster procurement.​"],
    descimg:selexicarus1
  },
  {
    name: "SelexSWS",
    route: "#",
    logo: selexsws,
    icon: <BubbleChartIcon />,
    tag: "Digital Twin & Optimization​",
    desc: "Sour-water-stripper performance & optimization for reliable H₂S/NH₃ removal and treated-water compliance.​",
    challenges:["Stripper upsets send H₂S/NH₃ to downstream units and flare safety and emission events.​","Off-spec stripped water breaches reuse, discharge and environmental limits.​","The unit is run conservatively on steam (wasteful) or pushed too hard (off-spec).​"],
    values:["Reliable H₂S/NH₃ removal with on-spec treated water.​","Protects compliance and downstream units from sour upsets.​","Balances stripping performance against steam and energy cost.​"],
    descimg:selexsws1
  },
  {
    name: "SelexStudio",
    route: "/selexsim/selexstudio/v3-0xp",
    logo: selexstudio,
    icon: <BubbleChartIcon />,
    tag: "Digital Twin & Optimization​",
    desc: "AI Digital-Twin platform to build, live plant models, layered with performance monitoring, soft sensors with ability to provide an open-loop optimizer​",
    challenges:["A plant digital twin normally needs specialist teams and long projects.​","Models built once are rarely kept live, so optimization value decays.​","Operators lack an easy advisory linking models to daily decisions.​"],
    values:["Build, train and deploy living plant digital twins without a specialist team.​","Open-loop optimizer turns models into actionable operating recommendations.​","Keeps the twin live so optimization value is sustained, not one-off.​"],
    descimg:selexstudio1
  },
   {
  name: "SelexRS",
  route: "/selexrs",
  logo: selexrs,
  icon: <BubbleChartIcon />,
  tag: "Digital Twin & Optimization",
  desc: "Mercaptans Extraction and Condensate Treatment Equation Oriented Model",
  challenges: [
    "Mercaptan slip in treated condensate breaches product RSH / total-sulfur and export specifications.",
    "Heavy mercaptans (C5+) resist caustic extraction, capping achievable removal and forcing conservative operation.",
    "Caustic over-circulation or over-strength wastes chemical and regeneration energy; under-dosing risks breakthrough.​"
  ],
  values: [
    "Reliable mercaptan removal with on-spec treated condensate, predicted per carbon number (C1–C9).",
    "Protects product sulfur specification and downstream / export compliance from extraction upsets.",
    "Supports stable operation and improved condensate treatment performance."
  ],
  descimg: selexrs1
},
   {
    name: "SelexDSM",
    route: "#",
    logo: selexdsm,
    icon: <BubbleChartIcon />,
    tag: "Digital Twin & Optimization​",
    desc: "AI-based Risk-aware operations layer and safety dashboard for Safety Digital Twins.​​",
    challenges:["Twin predictions reach operators as bare numbers, with no risk meaning.​","Twin predictions reach operators as bare numbers, with no risk meaning.​","Model outputs give no single plant-wide risk picture to act on.​"],
    values:["Turns every ML twin tag into a clear traffic-light state operator's trust.​","Turns every ML twin tag into a clear traffic-light state operator's trust.​","Operator-set thresholds link predictions straight to alerts and response.​"],
    descimg:selexdsm1
  },
  
   {
    name: "SelexOLE",
    route: "#",
    logo: selexole,
    icon: <BubbleChartIcon />,
    tag: "Digital Twin & Optimization​",
    desc: "Specialist Surrogate Model for Ethylene Process with ability of generating Big Data for AI Soft Sensing​​",
    challenges:["Rigorous flowsheet simulators are heavy, licensed, and hard to share across a team.​","Training surrogate / ML models needs thousands of case runs, generated by hand.​","Specs, feeds and stream conditions live in separate tools with no single interactive picture.​"],
    values:["A single-file, zero-install ethylene-plant flowsheet every unit and stream opens a live HYSYS-style datasheet.​","Per-unit ROM engine runs DoE across feeds and specs to build big labelled datasets in seconds.​","One-click SelexMB (CSV) and Excel export, editable feed compositions, for AI Digital Twins.​"],
    descimg:selexole1
  },
   {
    name: "SelexDMX",
    route: "#",
    logo: selexdmx,
    icon: <BubbleChartIcon />,
    tag: "Digital Twin & Optimization​",
    desc: "Corrosion Circuit Refinery supported with 20 mechanism of corrosion rate and DoE (Design of Experience)​​​",
    challenges:["Damage-mechanism screening lives in spreadsheets and group knowledge missed threats become leaks and unplanned shutdowns.​","Identifying mechanisms means cross-checking many standards (API 571 / 581 / 941 / 932-B, NACE) slowly and expert-dependently.​"],
    values:["Unified refinery flowsheet every unit opens a live datasheet with each mechanism's rate (mm/y) or susceptibility and the dominant threat.​","Per-unit ROM engine runs DoE across conditions to build big labelled corrosion datasets in seconds for AI soft-sensors and digital twins.​"],
    descimg:selexdmx1
  },
   {
    name: "SelexFZ",
    route: "/selexfz",
    logo: selexfz,
    icon: <BubbleChartIcon />,
    tag: "Ammonia-Plant Flowsheet,Calibration & ROM Data Generation​",
    desc: "Super ammonia-plant flowsheet across 17-unit operations with rigorous reactor and reformer equilibrium and a per-block calibration engine generating per-unit ROM (DoE) datasets for AI soft-sensor, digital-twin and SelexMB workflows.​​​",
    challenges:["Steam-reforming, shift and ammonia-synthesis performance lives in heavyweight licensed simulators slow to set up, hard to share with operations, and rarely reconciled to the live unit.​","Methane slip, CO conversion and per-pass ammonia yield are tuned by hand against scattered data, so engineering studies and AI models run on generic or out-of-date numbers.​"],
    values:["A single-file, zero-install ammonia-plant flowsheet every unit opens a live datasheet with rigorous SMR / shift / ammonia equilibrium and a one-click Calibration tab that reconciles each reactor to plant data.​","A per-unit ROM engine runs Latin-Hypercube DoE across operating conditions to build big, labelled datasets in seconds export-ready for AI soft-sensors."],
    descimg:selexfz1
  },
   {
    name: "SelexLNG",
    route: "#",
    logo: selexlng,
    icon: <BubbleChartIcon />,
    tag: "LNG Value-Chain Flowsheet,Calibration & ROM Data Generation​​",
    desc: "​Unified LNG value-chain flowsheet across 19- unit operations with rigorous PR/SRK equation-of-state thermodynamics and a per- block calibration engine producing per-unit ROM (DoE) datasets for AI soft-sensor, digital- twin and SelexMB workflows.​​",
    challenges:["Treating, liquefaction and NGL / helium-recovery performance lives in heavyweight licensed simulators slow to set up, hard to share with operations, and rarely reconciled to the live train.​","Liquefied fraction, specific power (kWh/t LNG) and column recoveries are tuned by hand against scattered data, so engineering studies and AI models run on generic or out-of-date numbers.​"],
    values:["A single-file, zero-install LNG value-chain flowsheet every unit opens a live datasheet with rigorous PR / SRK phase equilibrium and a one-click Calibration tab that reconciles each block to plant data.​","A per-unit ROM engine runs Latin-Hypercube DoE across operating conditions to build big, labelled datasets in seconds export-ready for AI soft-sensors.​"],
    descimg:selexlng1
  },
   {
    name: "SelexSRU",
    route: "/selexsru",
    logo: selexsru,
    icon: <BubbleChartIcon />,
    tag: "Digital Twin & Optimization​",
    desc: "​Modified-Claus flowsheet with rigorous S1–S8 sulphur thermodynamics and SulSim-aligned converters​",
    challenges:["Sulphur-recovery, tail-gas and SO₂-emissions performance lives in heavyweight licensed simulators (SulSim, ProMax) slow to set up, hard to share with operations, and rarely reconciled to the live train.​","Recovery efficiency, converter conversions, COS / CS₂ hydrolysis and stack SO₂ are tuned by hand against scattered data, so engineering studies and AI models run on generic or out-of-date numbers.​"],
    values:["Modified-Claus flowsheet every unit opens a live datasheet with rigorous S1–S8 sulphur thermodynamics and SulSim-aligned converters, plus a one-click Calibration tab that reconciles each block to plant data.​"],
    descimg:selexsru1
  },
   {
    name: "SelexLAB",
    route: "#",
    logo: selexlab,
    icon: <BubbleChartIcon />,
    tag: "LAB Complex Flowsheet,​Calibration & ROM Data Generation​",
    desc: "​Integrated flowsheet of linear alkyl benzene flowsheet for AI soft-sensor, digital-twin and SelexMB workflows.​",
    challenges:["Kerosene preparation, n-paraffin adsorption, dehydrogenation and alkylation performance lives in heavyweight licensed simulators slow to set up, hard to share with operations, and rarely reconciled to the live train.​","LAB yield, olefin selectivity, di-olefin make and column recoveries are tuned by hand against scattered data, so engineering studies and AI models run on generic or out-of-date numbers.​​"],
    values:["Flowsheet 20 blocks opens a live datasheet with rigorous PR / SRK phase equilibrium and a one- click Calibration tab that reconciles the block to plant data.​","A per-unit ROM engine runs DoE across the complete variable set every specification, inlet condition and computed response.​"],
    descimg:selexlab1
  },
  {
    name: "SelexHeater",
    route: "#",
    logo: selexheater,
    icon: <BubbleChartIcon />,
    tag: "Fired Heater Thermal Rating,​Performance Assessment & Emissions​​",
    desc: "​Rigorous Application for the Fired Heaters thermal rating and performance analysis of existing & installed based heater. Objectively is driven by Data Reconciliation, DoE and AI ROM Models to support operations​",
    challenges:["Fireboxes are carried as fixed-efficiency boxes, so tube metal temperature, run length and remaining capacity run on generic screening numbers rather than the heater’s own flux and fouling.​","Emissions sit outside the thermal model, leaving NOx, SOx and the acid dew point disconnected from firing rate, excess air and fuel switching.​"],
    values:["Gas, diesel or dual firing with a complete flue gas analysis CO2, H2O, O2, SO2, SO3, CO, NO, NO2 and a calibration engine that reconciles the model to plant data before a rating is trusted.​","A ROM engine runs Latin-hypercube DoE across every variable and exports in the SelexMB template for AI soft-sensors, digital twins and a formatted Excel report.​"],
    descimg:selexheater1
  },
  {
  name: "SelexRef",
  route: "/selexref",
  logo: selexref,
  icon: <BubbleChartIcon />,
  tag: "Refinery Product Specification, Off-Spec Prediction & Assay Management",
  desc: "Whole-refinery platform covering 23-unit operations from desalting to product blending, built on a 35-component pseudo-component slate and a Peng-Robinson / SRK cubic equation of state, with per component sulfur, nitrogen, metals, carbon and PIONA tracking, editable product specifications.",
  challenges: [
    "Yield models carry impurities as a single bulk number, so a cut-point move cannot tell you what it does to product sulfur, metals or cetane.",
    "Assays are entered as gravity and sulfur alone, and phase behavior comes from correlations — so flash zones, cut points and vapor pressure are approximations, not thermodynamics."
  ],
  values: [
    "Complete laboratory assays on nine ASTM distillation methods, expanded onto the component slate with impurities and metals distributed across the boiling range.",
    "Every product checked against an editable specification, and a reconciliation engine that solves the one input variable bound to each measurement."
  ],
  descimg: selexref1
},
  {
    name: "SelexP360",
    route: "#",
    logo: selexp360,
    icon: <BubbleChartIcon />,
    tag: "Phosphate Value Chain Flowsheet,​Calibration & ROM Data Generation​",
    desc: "Integrated platform of phosphate rock, sulphuric acid, phosphoric acid and granular fertilizer production across 37-unit operations with real-gas equation-of-state thermodynamics, reaction kinetics and a per-block calibration engine producing per-unit ROM (DoE) datasets for AI soft-sensor, digital-twin and SelexMB workflows.​",
    challenges:["Rock grade and dilution, attack efficiency, filtration rate, evaporator scaling and granulation recycle live in licensor packages and spreadsheets that are slow to set up, hard to share with operations and rarely reconciled to measured plant data.​"],
    values:["Platform with 37 blocks opens a live datasheet with PR / SRK real-gas thermodynamics, Arrhenius and equilibrium-limited reactor kinetics and Durand slurry hydraulics, with a Calibration engine that reconciles each block to plant data.​","A per-unit ROM engine runs DoE across every condition and computed response calibrated, no frozen variables export-ready for AI soft-sensors, digital twins, SelexMB and a formatted Excel engineering report.​"],
    descimg:selexp3601
  },
  {
    name: "SelexCMS",
    route: "#",
    logo: selexcms,
    icon: <BubbleChartIcon />,
    tag: "Corrosion Flowsheet, Calibration​ & ROM Data Generation​",
    desc: "Rigorous Application for the Corrosion rate for the Mid-stream domain of gas processing, gas treatment, NGL and Liquefaction. SelexCMS is driven by First Principles and Calibration, DoE and ROM to support operations gain insights and optimize operations ​​",
    challenges:["Corrosion rates for wet sour gas, amine, sulfur recovery, dehydration and LNG live in licensed RBI packages and spreadsheets that are slow to set up, hard to share with operations and rarely reconciled to measured wall loss.​"],
    values:["Platform with a 20 blocks opens a live datasheet with real-gas EOS thermodynamics, Arrhenius kinetics and API 571 / 581 damage mechanisms, with Calibration engine that reconciles the block to measured corrosion rates.​","A per-unit ROM engine runs DoE across every condition and computed response calibrated, no frozen variables export-ready for AI soft-sensors, digital twins and SelexMB.​"],
    descimg:selexcms1
  },
   {
    name: "SelexMPPL",
    route: "#",
    logo: selexmppl,
    icon: <BubbleChartIcon />,
    tag: "Digital Twin & Optimization​",
    desc: "Physics-based piping stress analysis to assess load effects, thermal movement and support reactions.​SelexMSA complies with EI guideline for the piping excitation modeling and assessment​ ​​",
    challenges:["Every batch change generates transmix; the interface spreads longer lines produce disproportionately more slop​","Receipt station cuts are set by rule of thumb cut wide and downgrade good product, cut narrow and contaminate the receiving tank​"],
    values:["Solves the advection–dispersion equation as written on a conservative finite-volume grid, with K evaluated from the local mixture cut times and transmix volume read off the solved outlet history​","Reconciles against measured slop volumes, with a correlation library and a tuning factor calibrated to the line, plus a numerical fidelity audit on every run​"],
    descimg:selexmppl1
  },
  {
    name: "SelexRXN",
    route: "#",
    logo: selexrxn,
    icon: <BubbleChartIcon />,
    tag: "Digital Twin & Optimization​",
    desc: "First-principles reaction engine covering catalyst deactivation, chemical equilibrium and batch CSTR kinetics, with calibration from plant data, case study and ROM (Reduced Order Model) for AI-based Solutions​",
    challenges:["Catalyst run length is guessed from fixed cycles, not from the deactivation the plant data already ows.​","Compensation temperature is raised by feel, wasting selectivity early or losing spec late.​"],
    values:["Fits the decay constant from one historian tag and forecasts end of run with the governing limit named.​​","Fits the decay constant from one historian tag and forecasts end of run with the governing limit named.​"],
    descimg:selexrxn1
  },
  {
    name: "SelexMSA",
    route: "#",
    logo: selexmsa,
    icon: <BubbleChartIcon />,
    tag: "Mechanical Stress Analysis​",
    desc: "Physics-based piping stress analysis to assess load effects, thermal movement and support reactions.​SelexMSA complies with EI guideline for the piping excitation modeling and assessment​",
    challenges:["Combined mechanical, thermal and pressure loads create complex piping stresses and deformation.​","Restrained expansion and poorly positioned supports can increase equipment and connection loads.​"],
    values:["Evaluate mechanical, thermal, pressure, wind and seismic load combinations using 3D frame analysis.​","Visualize forces, moments and displacements across piping routes, bends and supports.​"],
    descimg:selexmsa1
  },
  
  
];

function SelexSIMLanding() {
  const [openAppModal, setOpenAppModal] = React.useState(false);
const [selectedApp, setSelectedApp] = React.useState(null);
const [demoOpen, setDemoOpen] = React.useState(false);
const [demoForm, setDemoForm] = React.useState({
  name: "",
  email: "",
  phone: "",
  company: "",
  message: "",
});

const isLoggedIn = !!sessionStorage.getItem("usertoken");
const navigate = useNavigate();
const location = useLocation();

const handleAppClick = (app) => {
  setSelectedApp(app);
  setOpenAppModal(true);
};

const handleCloseAppModal = () => {
  setOpenAppModal(false);
  setSelectedApp(null);
};
const handleDemoChange = (e) => {
  setDemoForm({
    ...demoForm,
    [e.target.name]: e.target.value,
  });
};
const handleDemoSubmit = async () => {
  try {
    const response = await fetch(`${baseURL}/request-demo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...demoForm,
        to: "safiyanaaz@optimizegs.com",
      }),
    });

    if (response.ok) {
      alert("Demo Request for SelexSIM Submitted Successfully");
      setDemoOpen(false)
    } else {
      alert("Failed to submit request");
    }
  } catch (error) {
    console.error(error);
    alert("Something went wrong");

  }
};
  return (
    <Box
      sx={{
        minHeight: "100vh",
        background:"#fff",
        overflowX: "hidden",
        position: "relative",
      }}
    >
      <SelexSolNavbar isLoggedIn={!!sessionStorage.getItem("usertoken")}/>
      

      <Box
        sx={{
          width: "min(1280px, calc(100% - 32px))",
          mx: "auto",
          pt: { xs: 15, md: 18 },
          pb: 8,
        }}
      >
        {/* HERO */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1.1fr 0.9fr" },
            gap: 4,
            alignItems: "center",
            mb: { xs: 6, md: 8 },
          }}
        >
          <Box>
            <Box
                      component="img"
                      src={SelexSIM}
                      sx={{ width: 125, maxHeight: 125, objectFit: "contain" }}
                    />
            

            <Typography
              component="h1"
              sx={{
                fontSize: { xs: 40, sm: 54, md: 72 },
                lineHeight: 0.96,
                fontWeight: 950,
                letterSpacing: { xs: "-1.8px", md: "-3.4px" },
                color: navy,
                mb: 2,
                mt:2
              }}
            >
              Explore powerful <Box component="span" sx={{ color: primary }}>Selex</Box>
              <Box component="span" sx={{ color: accent }}>SIM™</Box> apps
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: 15, md: 18 },
                color: "#64748b",
                lineHeight: 1.8,
                maxWidth: 750,
                mb: 3.5,
              }}
            >
              High-fidelity dynamic simulation and optimization platform connecting subsurface, surface, and facilities to maximize throughput, recovery, energy efficiency, and asset life in real time.​
            </Typography>

            <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
              <Button href="#apps" endIcon={<ArrowForwardIcon />} sx={primaryBtn}>
                View Applications
              </Button>
              <Button onClick={() => setDemoOpen(true)} sx={outlineBtn}>
                Request Demo
                </Button>
            </Box>
          </Box>

          <Box
  id="overview"
  sx={{
    position: "relative",
    borderRadius: "34px",
    p: { xs: 3, md: 4 },

    background:
      "linear-gradient(135deg, rgba(255,255,255,0.96), rgba(248,251,255,0.94))",

    backdropFilter: "blur(18px)",

    overflow: "hidden",

    border: "1px solid rgba(0,120,201,0.16)",

    boxShadow: "0 24px 60px rgba(0,120,201,0.10)",

   
  }}
>
  <Box sx={{ position: "relative", zIndex: 2 }}>
    <Typography
      sx={{
        fontSize: 14,
        color: "#9e0b22",
        fontWeight: 800,
        mb: 1,
        letterSpacing: 1,
      }}
    >
      PLATFORM COVERAGE
    </Typography>

    <Typography
      sx={{
        fontSize: { xs: 34, md: 46 },
        fontWeight: 950,
        lineHeight: 1,
        mb: 3,
        color: "#0078c9",
      }}
    >
      25 Apps. 1 Simulation Ecosystem.
    </Typography>

    <Box sx={{ display: "grid", gap: 1.5 }}>
      {[
        [
          "Modeling",
          "Mathematical, regression, hybrid and surrogate models",
        ],
        [
          "Optimization",
          "AI-assisted optimization for industrial operations",
        ],
        [
          "Monitoring",
          "Wellhead, catalyst, separator and plant insights",
        ],
      ].map(([title, desc]) => (
        <Box
          key={title}
          sx={{
            p: 2,
            borderRadius: "18px",

            background:
              "linear-gradient(135deg, rgba(255,255,255,0.92), rgba(248,251,255,0.88))",

            border: "1px solid rgba(0,120,201,0.12)",

            boxShadow: "0 10px 28px rgba(0,120,201,0.06)",

            transition: ".3s",

            "&:hover": {
              transform: "translateY(-3px)",
              borderColor: "#0078c9",
              boxShadow: "0 18px 40px rgba(0,120,201,0.12)",
            },
          }}
        >
          <Typography
            sx={{
              fontWeight: 900,
              color: "#0078c9",
              mb: 0.4,
              fontSize: 16,
            }}
          >
            {title}
          </Typography>

          <Typography
            sx={{
              fontSize: 14,
              color: "#64748b",
              lineHeight: 1.6,
            }}
          >
            {desc}
          </Typography>
        </Box>
      ))}
    </Box>
  </Box>
</Box>
        </Box>

        {/* SECTION TITLE */}
        <Box sx={{ textAlign: "center", mb: 4 }} id="apps">
          <Typography
            sx={{
              color: accent,
              fontSize: 12,
              fontWeight: 950,
              letterSpacing: 1.2,
              textTransform: "uppercase",
              mb: 1,
            }}
          >
            Applications
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: 28, md: 42 },
              fontWeight: 950,
              color: navy,
              letterSpacing: "-1.4px",
              mb: 1.5,
            }}
          >
            Select a SelexSIM™ solution
          </Typography>
          <Typography sx={{ color: "#64748b", maxWidth: 760, mx: "auto", lineHeight: 1.75,fontSize:14 }}>
            Choose the application that fits your simulation, optimization, process monitoring, or AI inferential workflow.
          </Typography>
        </Box>

        {/* APPS GRID */}
       <Box
  sx={{
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      sm: "1fr 1fr",
      lg: "repeat(3, 1fr)",
    },
    gap: 3,
  }}
>
  {apps.map((app, index) => (
    <Box
      key={app.name}
      onClick={() => handleAppClick(app)}
      sx={{
        textDecoration: "none",
        position: "relative",
        minHeight: 300,
        p: 3,
        borderRadius: "30px",
        cursor: "pointer",
        overflow: "hidden",

        background:
          "linear-gradient(135deg, rgba(255,255,255,0.96), rgba(248,251,255,0.94))",

        border: "1px solid rgba(0,120,201,0.16)",

        boxShadow: "0 18px 48px rgba(0,120,201,0.10)",

        transition: "0.35s ease",

        "&:hover": {
          transform: "translateY(-10px)",
          boxShadow: "0 28px 75px rgba(0,120,201,0.18)",
          borderColor: primary,
        },

      
      }}
    >
      <Box sx={{ position: "relative", zIndex: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 3,
          }}
        >
          <Box
            sx={{
              width: 76,
              height: 76,
              borderRadius: "22px",
              bgcolor: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid rgba(0,120,201,0.12)",
              boxShadow: "0 14px 34px rgba(0,120,201,0.10)",
            }}
          >
            <Box
              component="img"
              src={app.logo}
              alt={app.name}
              sx={{
                width: 52,
                maxHeight: 52,
                objectFit: "contain",
              }}
            />
          </Box>

         
        </Box>

      
        <Typography
          sx={{
            fontSize: 24,
            fontWeight: 950,
            color: primary,
            mb: 1.2,
          }}
        >
          {app.name}
        </Typography>

        <Typography
          sx={{
            fontSize: 14,
            color: "#64748b",
            lineHeight: 1.75,
            mb: 3,
          }}
        >
          {app.desc}
        </Typography>

        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 0.8,
            color: primary,
            fontWeight: 900,
            fontSize: 14,
          }}
        >
          About <ArrowForwardIcon sx={{ fontSize: 17 }} />
        </Box>
      </Box>
    </Box>
  ))}
</Box>

              <Modal open={openAppModal} onClose={handleCloseAppModal}>
  <Box
    sx={{
      width: { xs: "92%", md: 1600 },
      bgcolor: "#fff",
      borderRadius: "18px",
      p: 0,
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      boxShadow: "0px 22px 65px rgba(6,29,52,0.22)",
      //border: "1px solid rgba(0,120,201,0.18)",
      overflow: "hidden",
    }}
  >
    {selectedApp && (
      <>
        {/* TOP BAR */}
        <Box
          sx={{
            height: 18,
            background: "linear-gradient(90deg,#061d34,#0078c9)",
          }}
        />

        <Box
          sx={{
            p: { xs: 2.5, md: 4 },
            display: "grid",
            gridTemplateColumns: {
  xs: "1fr",
  md: "250px 360px 1fr",
},
            gap: 3,
          }}
        >
          {/* LEFT PRODUCT CARD */}
          <Box component={Paper}
          elevation ={0} sx={{borderRadius: "18px"}}>
            <Box
              sx={{
                borderRadius: "18px",
                //border: "1px solid rgba(0,120,201,0.14)",
                overflow: "hidden",
                boxShadow: "0 14px 34px rgba(0,120,201,0.10)",
                height:"500px",
              }}
            >
            <Typography
              sx={{
                fontSize: { xs: 24, md: 24 },
                fontWeight: 950,
                color: "#fff",
                background:"#0078c9",
                mb: 2.5,
                px: 2,
                  py: 1.2,
              }}
            >
              {selectedApp.name}
            </Typography>
             

              <Box sx={{ p: 2.5 }}>
                <Box
                  sx={{
                    width: 76,
                    height: 76,
                    borderRadius: "50%",
                    bgcolor: "#f8fbff",
                    border: "1px solid #d9e9f7",
                    display: "grid",
                    placeItems: "center",
                    mb: 2,
                  }}
                >
                  <Box
                    component="img"
                    src={selectedApp.logo}
                    alt={selectedApp.name}
                    sx={{
                      width: 52,
                      maxHeight: 52,
                      objectFit: "contain",
                    }}
                  />
                </Box>

                <Typography
                  sx={{
                    fontSize: 13,
                    color: "#0078c9",
                    fontWeight: 800,
                    mb: 1,
                  }}
                >
                  {selectedApp.tag}
                </Typography>

                <Typography
                  sx={{
                    fontSize: 13,
                    color: "#061d34",
                    lineHeight: 1.7,
                    fontStyle: "italic",
                  }}
                >
                  {selectedApp.desc}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* RIGHT CONTENT */}
          <Box
          component={Paper}
          elevation ={1}
          sx={{height:"500px",border:"1px solid #fff",borderRadius: "14px"}}
          >
            

            {/* INDUSTRIAL CHALLENGES */}
            <Box
              sx={{
                borderRadius: "14px",
                overflow: "hidden",
                mb: 2,
                //border: "1px solid rgba(158,11,34,0.16)",
              }}
            >
              <Box
                sx={{
                  background: "#b42325",
                  color: "#fff",
                  px: 2,
                  py: 1,
                  fontSize: 12,
                  fontWeight: 900,
                  textTransform: "uppercase",
                }}
              >
                Industrial Challenges
              </Box>

              <Box sx={{ p: 2 }}>
                {(selectedApp.challenges).map((item) => (
                  <Typography
                    key={item}
                    sx={{
                      fontSize: 13,
                      color: "#061d34",
                      lineHeight: 1.7,
                      mb: 1,
                    }}
                  >
                    ▪ {item}
                  </Typography>
                ))}
              </Box>
            </Box>

            {/* VALUE PROPOSITION */}
            <Box
              sx={{
                borderRadius: "14px",
                overflow: "hidden",
                //border: "1px solid rgba(0,120,201,0.16)",
              }}
            >
              <Box
                sx={{
                  background: "#2878bd",
                  color: "#fff",
                  px: 2,
                  py: 1,
                  fontSize: 12,
                  fontWeight: 900,
                  textTransform: "uppercase",
                }}
              >
                Product Value Proposition
              </Box>

              <Box sx={{ p: 2 }}>
                {(selectedApp.values).map((item) => (
                  <Typography
                    key={item}
                    sx={{
                      fontSize: 13,
                      color: "#061d34",
                      lineHeight: 1.7,
                      mb: 1,
                    }}
                  >
                    ▪ {item}
                  </Typography>
                ))}
              </Box>
            </Box>
          </Box>

          <Box>
                          {selectedApp.descimg?.endsWith(".mp4") ? (
               <Box
                 component="video"
                 src={selectedApp.descimg}
                 controls
                 autoPlay
                 muted
                 loop
                 sx={{
                   width: 900,
                   height: "470px",
                   objectFit: "contain",
                 }}
               />
             ) : (
               <Box
                 component="img"
                 src={selectedApp.descimg}
                 alt={selectedApp.name}
                 sx={{
                   width: 900,
                   height: "470px",
                   objectFit: "contain",
                 }}
               />
             )}

        {/* FOOTER ACTIONS */}
        <Box
          sx={{
            px: { xs: 2.5, md: 4 },
            py: 2,
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            borderTop: "1px solid rgba(0,120,201,0.10)",
            background: "#f8fbff",
          }}
        >
          <Button
            onClick={handleCloseAppModal}
            variant="outlined"
            sx={{
              borderRadius: "12px",
              textTransform: "none",
              fontSize: "12px",
              fontWeight: 700,
              color: "#0078c9",
              borderColor: "#0078c9",
              "&:hover": {
                borderColor: "#9e0b22",
                color: "#9e0b22",
              },
            }}
          >
            Close
          </Button>

          {isLoggedIn ?  (
            <Button
              component="a"
              href={selectedApp.route}
              variant="contained"
              sx={{
                borderRadius: "12px",
                textTransform: "none",
                fontSize: "12px",
                fontWeight: 700,
                background: "linear-gradient(90deg,#0078c9,#0d8fe6)",
                boxShadow: "0px 8px 18px rgba(0,120,201,.25)",
                "&:hover": {
                  background: "#9e0b22",
                  color: "#fff",
                },
              }}
            >
              Go to {selectedApp.name} App
            </Button>
          ):(
                 <Button
                         onClick={() =>
                navigate("/login", {
                  state: { from: selectedApp.route }
                })
              }
                          sx={{
                            width: 140,
                            height: 44,
                            borderRadius: "14px",
                            background: "linear-gradient(135deg, #005da0, #005da0)",
                            color: "#fff",
                            transition: "0.3s",
                            textTransform: "none",
                            fontWeight: 700,
                            fontSize:14,
                      
                            "&:hover": {
                              background: "#9e0b22",
                              color: "#fff",
                              transform: "translateY(-2px)",
                            },
                          }}
                        >
                          Login
                        </Button>
          )}
        </Box>

        </Box>
        </Box>
      </>
    )}
  </Box>
</Modal>

<Modal open={demoOpen} onClose={() => setDemoOpen(false)}>
  <Box
    sx={{
      width: 430,
      bgcolor: "#fff",
      borderRadius: "26px",
      p: 3,
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      boxShadow: "0px 18px 55px rgba(6,29,52,0.18)",
      border: "1px solid rgba(0,120,201,0.14)",
    }}
  >
    <Typography sx={{ fontSize: 22, fontWeight: 900, color: "#0078c9", mb: 1 }}>
      Request Demo
    </Typography>

    <Typography sx={{ fontSize: 13, color: "#64748b", mb: 2 }}>
      Fill your details and our team will contact you.
    </Typography>

    {[
      { label: "Full Name", name: "name" },
      { label: "Business Email", name: "email" },
      { label: "Phone", name: "phone" },
      { label: "Company", name: "company" },
       { label: "Product", name: "product" },
      { label: "Message", name: "message", multiline: true },
    ].map((field) => (
      <TextField
        key={field.name}
        fullWidth
        size="small"
        label={field.label}
        name={field.name}
        multiline={field.multiline}
        rows={field.multiline ? 3 : 1}
        value={demoForm[field.name]}
        onChange={handleDemoChange}
        sx={{
          mb: 1.5,
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            fontSize: "14px",
          },
          "& .MuiInputLabel-root": {
            fontSize: "13px",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#d9e9f7",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#9e0b22",
          },
          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#0078c9",
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "#0078c9",
          },
        }}
      />
    ))}

    <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}>
      <Button
        onClick={() => setDemoOpen(false)}
        variant="outlined"
        sx={{
          borderRadius: "12px",
          textTransform: "none",
          color: "#0078c9",
          borderColor: "#0078c9",
          fontSize:"14px",
        }}
      >
        Cancel
      </Button>

      <Button
        onClick={handleDemoSubmit}
        variant="contained"
        sx={{
          borderRadius: "12px",
          textTransform: "none",
          fontSize:"14px",
          background: "linear-gradient(90deg,#0078c9,#0d8fe6)",
          boxShadow: "0px 8px 18px rgba(0,120,201,.25)",
          "&:hover": {
            background: "#9e0b22",
          },
        }}
      >
        Send Request
      </Button>
    </Box>
  </Box>
</Modal>



                {/* ENGINEERING WORKFLOW */}
        <Box sx={{ py: { xs: 7, md: 10 } }}>
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <Typography sx={{ color: accent, fontSize: 12, fontWeight: 950, letterSpacing: 1.2, textTransform: "uppercase", mb: 1 }}>
              Engineering Workflow
            </Typography>
            <Typography sx={{ fontSize: { xs: 28, md: 42 }, fontWeight: 950, color: navy, letterSpacing: "-1.4px", mb: 1.5 }}>
              From model definition to decision support
            </Typography>
            <Typography sx={{ color: "#64748b", maxWidth: 780, mx: "auto", lineHeight: 1.75,fontSize:14 }}>
              SelexSIM guides engineers through a complete workflow so every simulation case, optimization result, and report remains structured and traceable.
            </Typography>
          </Box>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(6, 1fr)" },
              gap: 2,
              p: { xs: 2, md: 3 },
              borderRadius: "34px",
              background: "#fff",
              border: "1px solid rgba(0,120,201,0.12)",
              boxShadow: "0 18px 55px rgba(6,29,52,0.08)",
            }}
          >
            {["Define", "Simulate", "Validate", "Compare", "Optimize", "Report"].map((step, index) => (
              <Box
                key={step}
                sx={{
                  minHeight: 118,
                  borderRadius: "24px",
                  p: 2,
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  background: "#fff",
                  color: "#0078c9",
                  position: "relative",
                  overflow: "hidden",
                  border: "1px solid navy",
                 
                }}
              >
                <Typography sx={{ position: "relative", zIndex: 2, color: "#9e0b22", fontSize: 12, fontWeight: 950, mb: 0.8 }}>
                  0{index + 1}
                </Typography>
                <Typography sx={{ position: "relative", zIndex: 2, fontSize: 16, fontWeight: 950 }}>
                  {step}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

                {/* INDUSTRIAL APPLICATIONS + WHY SELEXSIM */}
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1.1fr 0.9fr" }, gap: 3, pb: { xs: 7, md: 10 } }}>
          <Box
            sx={{
              p: { xs: 3, md: 4 },
              borderRadius: "34px",
              background: "#fff",
              color: "#fff",
              boxShadow: "0 24px 70px rgba(6,29,52,0.18)",
              border: "1px solid navy",
              position: "relative",
              overflow: "hidden",
             
            }}
          >
            <Box sx={{ position: "relative", zIndex: 2 }}>
              <Typography sx={{ color: "#9e0b22", fontSize: 18, fontWeight: 950, letterSpacing: 1,  mb: 1 }}>
                Industrial Applications
              </Typography>
              <Typography sx={{ color: "#0078c9", fontSize: { xs: 28, md: 38 }, fontWeight: 950, mb: 2, letterSpacing: "-1px" }}>
                Built for real process engineering studies
              </Typography>
              <Typography sx={{ color: "#000", lineHeight: 1.8, mb: 3 ,fontSize:14}}>
                SelexSIM supports engineering teams working across production, refinery, utilities, process monitoring, and AI-based optimization workflows.
              </Typography>

              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.2 }}>
                {["Oil & Gas Production", "Gas Processing", "NGL Fractionation", "Separation Systems", "Compression", "Utilities", "Energy Optimization", "Digital Twin Monitoring"].map((tag) => (
                  <Chip key={tag} label={tag} sx={{ bgcolor: "#0078c9", fontSize:16,color: "#fff", border: "1px solid rgba(255,255,255,0.12)", fontWeight: 800 }} />
                ))}
              </Box>
            </Box>
          </Box>

          <Box sx={{ p: { xs: 3, md: 4 }, borderRadius: "34px", background: "#fff", border: "1px solid navy", boxShadow: "0 18px 55px rgba(6,29,52,0.08)" }}>
            <Typography sx={{ color: accent, fontSize: 18, fontWeight: 950, letterSpacing: 1, mb: 1 }}>
              Why SelexSIM?
            </Typography>
            <Typography sx={{ color: "#0078c9", fontSize: { xs: 28, md: 38 }, fontWeight: 950, mb: 3, letterSpacing: "-1px" }}>
              Smarter than a simple simulation menu
            </Typography>

            <Box sx={{ display: "grid", gap: 1.5 }}>
              {[
                ["Advanced Process Simulation Platform", "Web & Desktop Accessibility"],
                ["Nodal Analysis Engine", "Big Data Generation for AI Applications"],
                ["Material Selection Intelligence", "Sour Water Stripper Optimization"],
                ["Digital Twin & Soft Sensor Enablement", "Gas Dehydration Performance Analysis"],
              ].map(([before, after]) => (
                <Box key={before} sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 1.2 }}>
                  <Box sx={{ p: 1.8, borderRadius: "18px", bgcolor: "rgba(0,120,201,0.07)", color: navy, border: "1px solid rgba(0,120,201,0.16)", fontSize: 14, fontWeight: 700, lineHeight: 1.5 }}>
                    {before}
                  </Box>
                  <Box sx={{ p: 1.8, borderRadius: "18px", bgcolor: "rgba(0,120,201,0.07)", color: navy, border: "1px solid rgba(0,120,201,0.16)", fontSize: 14, fontWeight: 700, lineHeight: 1.5 }}>
                    {after}
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>




      </Box>
      <Footer />
    </Box>
  );
}

const primaryBtn = {
  px: 3,
  py: 1.35,
  borderRadius: "999px",
  background: `linear-gradient(135deg, ${primary}, #005b98)`,
  color: "#fff",
  fontWeight: 900,
    fontSize:14,

  textTransform: "none",
  boxShadow: "0 14px 34px rgba(0,120,201,0.28)",
  "&:hover": {
    background: `linear-gradient(135deg, ${accent}, #75081a)`,
    transform: "translateY(-2px)",
    boxShadow: "0 18px 40px rgba(158,11,34,0.28)",
    color:"#fff"
  },
};

const outlineBtn = {
  px: 3,
  py: 1.35,
  borderRadius: "999px",
  color: primary,
  fontWeight: 900,
    fontSize:14,

  textTransform: "none",
  background: "#fff",
  border: "1px solid rgba(0,120,201,0.25)",
  "&:hover": {
    color: accent,
    borderColor: accent,
    background: "rgba(158,11,34,0.04)",
    transform: "translateY(-2px)",
  },
};

export default SelexSIMLanding;
